<template>
  <el-dialog
    title="新增商品"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >
      <el-form-item
        prop="goodsname"
        label="商品名称"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.goodsname"></el-input>
      </el-form-item>
      <el-form-item
              prop="type_video"
              label="消费类型"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.type_video"
                placeholder="请选择消费类型"
        >
          <el-option
                  v-for="item in type_video_itemArray"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="bar_code"
        label="条形码"
      >
        <el-input v-model="form.bar_code"></el-input>
      </el-form-item>
      <el-form-item
              prop="googs_no"
              label="商品编号"
      >
        <el-input v-model="form.googs_no"></el-input>
      </el-form-item>
        <el-form-item label="封面图片" prop="goodsimg22"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form.goodsimg22" style="display:none"></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=10
                  :auto-upload="true"
                  :file-list="fileList"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove"
                  :on-success="handlePictureCardPreview">
            <i class="el-icon-plus"></i>
          </el-upload>
        建议尺寸1000*600像素，大小7M以内，支持jpg、png、jpeg格式
      </el-form-item>
      <el-form-item
        prop="googstype_id"
        label="平台一级分类"
      >
        <el-select
                class="filter-item"
                v-model="form.googstype_id"
                @change="currentBusinessSel(form.googstype_id)"
                placeholder="请选择商品分类"
        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.businessid"
                  :label="item.businessname"
                  :value="item.businessid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="googstype_id_two"
              label="平台二级分类"
      >
        <el-select
                multiple
                collapse-tags
                class="filter-item"
                v-model="form.googstype_id_two"
                placeholder="请选择二级分类"
        >
          <el-option
                  v-for="item in typeOptions2"
                  :key="item.two_businessid"
                  :label="item.two_businessname"
                  :value="item.two_businessid"
          ></el-option>
        </el-select>
      </el-form-item>


      <el-form-item
              prop="agent_one_id"
              label="商家一级分类"
              v-if="is_ts4"
      >
        <el-select
                class="filter-item"
                v-model="form.agent_one_id"
                @change="currentBusinessSelAgent(form.agent_one_id)"
                placeholder="请选择商品分类"
        >
          <el-option
                  v-for="item in bussOptions"
                  :key="item.id"
                  :label="item.businessname"
                  :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="agent_two_id"
              label="商家二级分类"
              v-if="is_ts4"
      >
        <el-select
                multiple
                collapse-tags
                class="filter-item"
                v-model="form.agent_two_id"
                placeholder="请选择二级分类"
        >
          <el-option
                  v-for="item in typeOptions22"
                  :key="item.id"
                  :label="item.two_businessname"
                  :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
              prop="is_dltype"
              v-if="is_ts"
              label="联盟商品级别"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.is_dltype"
                placeholder="请选择联盟商品级别"
        >
          <el-option
                  v-for="item in dltypeOptions"
                  :key="item.businessid"
                  :label="item.businessname"
                  :value="item.businessid"
          ></el-option>
        </el-select>
      </el-form-item>


      <el-form-item
              prop="is_menu"
              label="联盟菜单分类"
              v-if="is_ts2"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.is_menu"
                placeholder="请选择联盟菜单分类"
        >
          <el-option
                  v-for="item in menuOptions"
                  :key="item.businessid"
                  :label="item.businessname"
                  :value="item.businessid"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
              prop="is_download"
              label="联盟商品类型"
              v-if="is_ts3"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.is_download"
                placeholder="请选择联盟商品类型"
        >
          <el-option
                  v-for="item in downloadOptions"
                  :key="item.businessid"
                  :label="item.businessname"
                  :value="item.businessid"
          ></el-option>
        </el-select>
      </el-form-item>



      <el-form-item
              prop="ruletype_id"
              label="规格分类"
      >
        <el-cascader
                :options="options"
                :props="{ multiple: true, checkStrictly: 'true'}"
                v-model="form.ruletype_id"
                @change="handleChange">
        </el-cascader>
      </el-form-item>

      <el-form-item
              prop="frequency"
              label="购买数量"
              :rules="[{ required: true, message: '不能为空'}]"
      >

        <el-select
                class="filter-item"
                v-model="form.frequency"
                @change="currentFrequencySel(form.frequency)"
                placeholder="购买数量"
        >
          <el-option
                  v-for="item in frequencyOptions"
                  :key="item.businessid"
                  :label="item.businessname"
                  :value="item.businessid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="cs_unit"
              v-if="is_unit"
              label="限制数量"
      >
        <el-input-number v-model="form.cs_unit"  :min="1" style="width:100px"></el-input-number>
      </el-form-item>



      <el-form-item
              prop="share_commission"
              label="分享返佣比例"
              :rules="[{ required: true, message: '不能为空'}]"
      >

        <el-select
                class="filter-item"
                v-model="form.share_commission"
                placeholder="分享返佣比例"
        >
          <el-option
                  v-for="item in shareOptions"
                  :key="item.businessid"
                  :label="item.businessname"
                  :value="item.businessid"
          ></el-option>
        </el-select>
      </el-form-item>


      <el-form-item
              prop="originalprice"
              label="原价格"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.originalprice" style="width:100px"></el-input>元
      </el-form-item>
      <el-form-item
              prop="goodsprice"
              label="优惠价格"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.goodsprice" style="width:100px"></el-input>元
      </el-form-item>

      <el-form-item
              prop="total_num"
              label="库存"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.total_num"></el-input>
      </el-form-item>
      <el-form-item
              prop="valuation_unit"
              label="计价单位"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.valuation_unit"></el-input>
      </el-form-item>
      <el-form-item label="商品详情图" prop="goodsimg2">
        <el-input v-model="form.goodsimg2" style="display:none"></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=30
                :auto-upload="true"
                :file-list="fileList2"
                :before-upload="handleBeforeUpload2"
                :on-remove="handleRemove2"
                :on-success="handlePictureCardPreview2">
          <i class="el-icon-plus"></i>
        </el-upload>
        建议尺寸1000*600像素，大小7M以内，支持jpg、png、jpeg格式
      </el-form-item>

      <el-form-item   label="商品封面视频" prop="advImg" >
        <el-input v-model="form.advImg" style="display:none"></el-input>
        <el-upload class="avatar-uploader"
                   :action="videoUrl"
                   v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                   v-bind:on-progress="uploadVideoProcess"
                   v-bind:on-success="handleVideoSuccess"
                   v-bind:before-upload="beforeUploadVideo"
                   v-bind:show-file-list="true">
          <video v-if="form.showVideoPath !='' && !videoFlag"
                 v-bind:src="form.showVideoPath"
                 class="avatar video-avatar"
                 controls="controls"  style="width: 500px;height: 500px; ">
            您的浏览器不支持视频播放
          </video>
          <i v-else-if="form.showVideoPath =='' && !videoFlag"
             class="el-icon-plus avatar-uploader-icon"></i>
          <el-progress v-if="videoFlag == true"
                       type="circle"
                       v-bind:percentage="videoUploadPercent"
                       style="margin-top:7px;"></el-progress>

        </el-upload>
        <div><el-button @click="handleRemoveVideo">删除商品封面视频</el-button>　　最多可以上传1个视频，建议大小50M，推荐格式mp4</div>
      </el-form-item>


      <el-form-item   label="商品详情视频" prop="advImg2" >
        <el-input v-model="form.advImg2" style="display:none"></el-input>
        <el-upload class="avatar-uploader"
                   :action="videoUrl"
                   v-bind:data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                   v-bind:on-progress="uploadVideoProcess2"
                   v-bind:on-success="handleVideoSuccess2"
                   v-bind:before-upload="beforeUploadVideo2"
                   v-bind:show-file-list="true">
          <video v-if="form.showVideoPath2 !='' && !videoFlag2"
                 v-bind:src="form.showVideoPath2"
                 class="avatar video-avatar"
                 controls="controls"  style="width: 500px;height: 500px; ">
            您的浏览器不支持视频播放
          </video>
          <i v-else-if="form.showVideoPath2 =='' && !videoFlag2"
             class="el-icon-plus avatar-uploader-icon"></i>
          <el-progress v-if="videoFlag2 == true"
                       type="circle"
                       v-bind:percentage="videoUploadPercent2"
                       style="margin-top:7px;"></el-progress>
        </el-upload>
        <div><el-button @click="handleRemoveVideo2">删除商品详情视频</el-button>　最多可以上传1个视频，建议大小50M，推荐格式mp4</div>
      </el-form-item>

        <el-form-item
                prop="goodsnote"
                label="商品介绍"
        >

          <el-input type="textarea" placeholder="..."  style="width: 90%;" :rows="6" maxlength="500" @input = "descInput" v-model="form.goodsnote">

          </el-input>
          <span class="circle"></span><span class="text">{{remnant}}/500</span>

        </el-form-item>
      <el-form-item
      >
        <el-checkbox v-model="checked">上架</el-checkbox>



      </el-form-item>
      <el-form-item  v-if="formEdit">
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
export default {
  name: "oneclassEditForm",
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
      options: [],
      selectedOptions: [],
        imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
      videoUrl: process.env.VUE_APP_API+"/moblieapp/videoUploadPc",
        formEdit: true,
        checked:true,
      is_unit: false,
      is_ts: false,
      is_ts2: false,
      is_ts3: false,
      is_ts4: false,
      loading: false,
      dialogVisible: false,
        dialogImageUrl: '',
        fileList: [],
        fileList1: [],
        fileList2: [],
        fileList3: [],
        imageNum: 0 ,
        remnant:0,//输入数
      videoFlag: false,
      videoFlag2: false,
      //是否显示进度条
      videoUploadPercent: "",
      videoUploadPercent2: "",
      //进度条的进度，
      isShowUploadVideo: false,
      isShowUploadVideo2: false,
        pickerOptions:{},
        typeOptions: [],
      typeOptions2: [],
      typeOptions22: [],
      menuOptions: [],
      bussOptions: [],
      dltypeOptions: [],
      downloadOptions: [],
      type_video_itemArray: [
        {
          name: '快递邮寄',
          value: '0'
        },
        {
          name: '到店消费',
          value: '1'
        }
      ],
      shareOptions: [
        {
          businessname: '1%',
          businessid: '1'
        },{
          businessname: '2%',
          businessid: '2'
        },{
          businessname: '3%',
          businessid: '3'
        },{
          businessname: '4%',
          businessid: '4'
        },{
          businessname: '5%',
          businessid: '5'
        },{
          businessname: '6%',
          businessid: '6'
        },{
          businessname: '7%',
          businessid: '7'
        },{
          businessname: '8%',
          businessid: '8'
        },{
          businessname: '9%',
          businessid: '9'
        },{
          businessname: '10%',
          businessid: '10'
        },{
          businessname: '11%',
          businessid: '11'
        },{
          businessname: '12%',
          businessid: '12'
        },{
          businessname: '13%',
          businessid: '13'
        },{
          businessname: '14%',
          businessid: '14'
        },{
          businessname: '15%',
          businessid: '15'
        },{
          businessname: '16%',
          businessid: '16'
        },{
          businessname: '17%',
          businessid: '17'
        },{
          businessname: '18%',
          businessid: '18'
        },{
          businessname: '19%',
          businessid: '19'
        },{
          businessname: '20%',
          businessid: '20'
        },{
          businessname: '21%',
          businessid: '21'
        },{
          businessname: '22%',
          businessid: '22'
        },{
          businessname: '23%',
          businessid: '23'
        },{
          businessname: '24%',
          businessid: '24'
        },{
          businessname: '25%',
          businessid: '25'
        },{
          businessname: '26%',
          businessid: '26'
        },{
          businessname: '27%',
          businessid: '27'
        },{
          businessname: '28%',
          businessid: '28'
        },{
          businessname: '29%',
          businessid: '29'
        },{
          businessname: '30%',
          businessid: '30'
        },{
          businessname: '31%',
          businessid: '31'
        },{
          businessname: '32%',
          businessid: '32'
        },{
          businessname: '33%',
          businessid: '33'
        },{
          businessname: '34%',
          businessid: '34'
        },{
          businessname: '35%',
          businessid: '35'
        },{
          businessname: '36%',
          businessid: '36'
        },{
          businessname: '37%',
          businessid: '37'
        },{
          businessname: '38%',
          businessid: '38'
        },{
          businessname: '39%',
          businessid: '39'
        },{
          businessname: '40%',
          businessid: '40'
        },{
          businessname: '41%',
          businessid: '41'
        },{
          businessname: '42%',
          businessid: '42'
        },{
          businessname: '43%',
          businessid: '43'
        },{
          businessname: '44%',
          businessid: '44'
        },{
          businessname: '45%',
          businessid: '45'
        },{
          businessname: '46%',
          businessid: '46'
        },{
          businessname: '47%',
          businessid: '47'
        },{
          businessname: '48%',
          businessid: '48'
        },{
          businessname: '49%',
          businessid: '49'
        },{
          businessname: '50%',
          businessid: '50'
        },{
          businessname: '51%',
          businessid: '51'
        },{
          businessname: '52%',
          businessid: '52'
        },{
          businessname: '53%',
          businessid: '53'
        },{
          businessname: '54%',
          businessid: '54'
        },{
          businessname: '55%',
          businessid: '55'
        },{
          businessname: '56%',
          businessid: '56'
        },{
          businessname: '57%',
          businessid: '57'
        },{
          businessname: '58%',
          businessid: '58'
        },{
          businessname: '59%',
          businessid: '59'
        },{
          businessname: '60%',
          businessid: '60'
        },{
          businessname: '61%',
          businessid: '61'
        },{
          businessname: '62%',
          businessid: '62'
        },{
          businessname: '63%',
          businessid: '63'
        },{
          businessname: '64%',
          businessid: '64'
        },{
          businessname: '65%',
          businessid: '65'
        },{
          businessname: '66%',
          businessid: '66'
        },{
          businessname: '67%',
          businessid: '67'
        },{
          businessname: '68%',
          businessid: '68'
        },{
          businessname: '69%',
          businessid: '69'
        },{
          businessname: '70%',
          businessid: '70'
        },{
          businessname: '71%',
          businessid: '71'
        },{
          businessname: '72%',
          businessid: '72'
        },{
          businessname: '73%',
          businessid: '73'
        },{
          businessname: '74%',
          businessid: '74'
        },{
          businessname: '75%',
          businessid: '75'
        },{
          businessname: '76%',
          businessid: '76'
        },{
          businessname: '77%',
          businessid: '77'
        },{
          businessname: '78%',
          businessid: '78'
        },{
          businessname: '79%',
          businessid: '79'
        },{
          businessname: '80%',
          businessid: '80'
        },{
          businessname: '81%',
          businessid: '81'
        },{
          businessname: '82%',
          businessid: '82'
        },{
          businessname: '83%',
          businessid: '83'
        },{
          businessname: '84%',
          businessid: '84'
        },{
          businessname: '85%',
          businessid: '85'
        },{
          businessname: '86%',
          businessid: '86'
        },{
          businessname: '87%',
          businessid: '87'
        },{
          businessname: '88%',
          businessid: '88'
        },{
          businessname: '89%',
          businessid: '89'
        },{
          businessname: '90%',
          businessid: '90'
        },{
          businessname: '91%',
          businessid: '91'
        },{
          businessname: '92%',
          businessid: '92'
        },{
          businessname: '93%',
          businessid: '93'
        },{
          businessname: '94%',
          businessid: '94'
        },{
          businessname: '95%',
          businessid: '95'
        },{
          businessname: '96%',
          businessid: '96'
        },{
          businessname: '97%',
          businessid: '97'
        },{
          businessname: '98%',
          businessid: '98'
        },{
          businessname: '99%',
          businessid: '99'
        },{
          businessname: '100%',
          businessid: '100'
        }
      ],
      frequencyOptions: [
        {
          businessname: '无限制',
          businessid: '0'
        },{
          businessname: '单月限制',
          businessid: '1'
        }
      ],
        ruletypeOptions: [],
        ruletype_id: [],
      form: {
        frequency:'',
        goodsimg22:'',
        pay_type:1,
        advImg:"",
        advImg2:"",
        showVideoPath: '',
        showVideoPath2: '',
        googstype_id_two: [],
        agent_two_id: [],
          dateRange: []
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
      descInput(){
          var txtVal = this.form.goodsnote.length;
          this.remnant = txtVal;
      },
    handleChange(value) {
      console.log("======"+value.length);
      for(let i=0;i<value.length;i++){
        console.log("======"+value[i]);
      }

    },
    dialogOpen() {
      this.$refs.form.resetFields();
        var formData2 = new FormData() // 声明一个FormData对象
        formData2.append('agentid', util.cookies.get('agentid'));
      agentService.getOneIntegral(formData2).then(data => {
        this.typeOptions=data;
      });
      let query = {
        agentid: util.cookies.get('agentid')
      };
      agentService.getModuleFunction(query).then(data => {
          console.info("8888");
          console.info(data);
          if(data.data){
            this.is_ts=true;
            this.is_ts4=true;
          }
            this.dltypeOptions=data.data;
          if(data.menudata){
            this.is_ts2=true;
          }
          this.menuOptions=data.menudata;
        if(data.purchasedata){
          this.is_ts3=true;
        }
        this.downloadOptions=data.purchasedata;
        this.bussOptions=data.bussdata;

        });

      //  agentService.getRuletyps(formData2).then(data => {
            //this.ruletypeOptions=data;
        //});
      agentService.getRuletypsNew(formData2).then(data => {
        this.options=data;
      });
        this.fileList2=[];
        this.fileList3=[];
      this.fileList=[];
      this.fileList1=[];
      if(this.oneagent.googstype_id_two){
        this.currentBusinessSel(this.oneagent.googstype_id);
      }
      if(this.oneagent.agent_two_id){
        this.currentBusinessSelAgent(this.oneagent.agent_one_id);
      }
        if (this.oneagent.id) {
            // userService.getUser(this.user.id).then(data => {
            let form = {};
            form.goodsname = this.oneagent.goodsname;
            form.bar_code = this.oneagent.bar_code;
            form.googs_no = this.oneagent.googs_no;
            form.googstype_id =this.oneagent.googstype_id;
          if(this.oneagent.agent_one_id!=null && this.oneagent.agent_one_id!="") {
            form.agent_one_id = parseInt(this.oneagent.agent_one_id);
          }
          form.type_video=this.oneagent.type_video;

          if(this.oneagent.share_commission!=null && this.oneagent.share_commission!="") {
            form.share_commission = this.oneagent.share_commission;
          }
          if(this.oneagent.frequency!=null && this.oneagent.frequency!="") {
            if(this.oneagent.frequency==0){
              this.is_unit=false;
              form.frequency = this.oneagent.frequency;
            }else{
              form.cs_unit=this.oneagent.frequency;
              form.frequency = "1";
              this.is_unit=true;
            }
          }
          if(this.oneagent.pay_type!=null && this.oneagent.pay_type!=""&& this.oneagent.pay_type!="null") {
            form.pay_type = this.oneagent.pay_type;
          }

          if(this.oneagent.is_menu!=null && this.oneagent.is_menu!="") {
            form.is_menu = this.oneagent.is_menu;
          }
          if(this.oneagent.is_dltype!=null && this.oneagent.is_dltype!="") {
            form.is_dltype = this.oneagent.is_dltype;
          }
          if(this.oneagent.is_download!=null && this.oneagent.is_download!="") {
            form.is_download = this.oneagent.is_download;
          }


          if(this.oneagent.googstype_id_two!=null && this.oneagent.googstype_id_two!=""){

            let countlistArray2=[];
            let strs2 = this.oneagent.googstype_id_two.split(","); //字符分割

            for ( let i=0; i<strs2.length; i++ ){
              countlistArray2.push(strs2[i]);
            }
            form.googstype_id_two=countlistArray2;


          }else{
            form.googstype_id_two =[];
          }

          if(this.oneagent.agent_two_id!=null && this.oneagent.agent_two_id!=""){

            let countlistArray2=[];
            let strs2 = this.oneagent.agent_two_id.split(","); //字符分割

            for ( let i=0; i<strs2.length; i++ ){
              countlistArray2.push(parseInt(strs2[i]));
            }
            form.agent_two_id=countlistArray2;


          }else{
            form.agent_two_id =[];
          }

            if(this.oneagent.ruletype_id!=null && this.oneagent.ruletype_id!=""){
                let countlistArray=[];
               let strs = this.oneagent.ruletype_id.split(","); //字符分割

                for ( let i=0; i<strs.length; i++ ){
                    countlistArray.push(parseInt(strs[i]));
                  if(this.oneagent.ruletype_id_two!=null && this.oneagent.ruletype_id_two!=""){
                    let strs2 = this.oneagent.ruletype_id_two.split(","); //字符分割
                    if(strs2[i]!=0){
                      let strs22 =strs2[i].split("-")
                      for ( let j=0; j<strs22.length; j++ ) {
                        countlistArray.push(parseInt(strs[i])+","+parseInt(strs22[j]));

                      }

                    }

                  }
                }


                form.ruletype_id=countlistArray;

            }else{
                form.ruletype_id  =[];
            }

            form.goodsprice = this.oneagent.goodsprice;
            form.originalprice = this.oneagent.originalprice;
            form.total_num = this.oneagent.total_num;
            form.valuation_unit = this.oneagent.valuation_unit;
            //form.goodsnote = decodeURIComponent(this.oneagent.goodsnote);
          form.goodsnote = this.oneagent.goodsnote;
            if(this.oneagent.goodsimg!=null && this.oneagent.goodsimg!="") {
              let tmpCenter = this.oneagent.goodsimg.split(',');
              for (let index = 0; index < tmpCenter.length; index++) {
                if (tmpCenter[index].indexOf('mp4') != -1) {
                  //this.fileList1.push(tmpCenter[index]);
                  // form.goodsimg = tmpCenter[1];
                  // this.fileList = [{url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + tmpCenter[1]}]
                  form.showVideoPath = "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/" + tmpCenter[index];
                  form.advImg = tmpCenter[index];
                } else {
                  form.goodsimg22 ="1";
                  this.fileList1.push(tmpCenter[index]);
                  this.fileList.push({
                    url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + tmpCenter[index],
                    url22: tmpCenter[index]
                  });
                  //form.goodsimg = tmpCenter[0];
                  //this.fileList = [{url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + tmpCenter[0]}]
                }
              }
            }
            if(this.oneagent.detailsimg!=null && this.oneagent.detailsimg!="") {
                let tmpCenter = this.oneagent.detailsimg.split(',');
                for (let index = 0; index < tmpCenter.length; index++) {
                  if(tmpCenter[index].indexOf('mp4') ==-1) {
                    this.fileList3.push(tmpCenter[index]);
                    this.fileList2.push({
                      url: 'https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/' + tmpCenter[index],
                      url22: tmpCenter[index]
                    });
                  }else{
                    form.showVideoPath2 = "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/" + tmpCenter[index];
                    form.advImg2 = tmpCenter[index];
                  }
                }
            }

            if(this.oneagent.types=='0'){
                this.checked=true;
            }else{
                this.checked=false;
            }
            this.form = form;
            // });
            this.formEdit = true;

        } else {
            this.fileList=[];
            this.fileList2=[];
            this.fileList3=[];
            this.formEdit = true;
            this.form = {};
        }
    },
    currentBusinessSel(val) {
      this.form.googstype_id_two="";
      this.typeOptions2=[];
      var formData2 = new FormData() // 声明一个FormData对象

      formData2.append('businessid',val)
      agentService.getTwoIntegral(formData2).then(data => {
        this.typeOptions2=data;
      });
    },
    currentBusinessSelAgent(val) {
      this.form.agent_two_id="";
      this.typeOptions22=[];
      var formData2 = new FormData() // 声明一个FormData对象

      formData2.append('businessid',val)
      agentService.getTwoIntegralAgent(formData2).then(data => {
        this.typeOptions22=data;
      });
    },
    currentFrequencySel(val) {
     if(val ==1){
       this.is_unit=true;

     }else{
       this.is_unit=false;
     }
    },
      // 上传文件之前的钩子
      handleBeforeUpload(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024
          if(size > 7) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于7M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },

      // 文件列表移除文件时的钩子
      handleRemove(file, fileList) {
         // this.form.goodsimg ="";
        //  this.dialogVisible = true;

        console.log("url222==="+JSON.stringify(fileList));
        this.fileList1=[];
        for (let index = 0; index < fileList.length; index++) {
          if(fileList[index].response!=null){
            console.log("url5555==="+fileList[index].response.url);
            this.fileList1.push(fileList[index].response.url);
          }else{
            console.log("url5555==="+fileList[index].url22);
            this.fileList1.push(fileList[index].url22);
          }
        }
        this.form.goodsimg22 ="1";
        this.dialogVisible = true;

      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview(file) {
         // console.log("url==="+file.url);
          //this.form.goodsimg = file.url;
          //this.dialogVisible = true;
        console.log("url==="+file.url);
        this.fileList1.push(file.url);
        this.form.goodsimg22 = "1";
        this.dialogVisible = true;
      },

      // 上传文件之前的钩子
      handleBeforeUpload2(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024
          if(size > 7) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于7M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },

      // 文件列表移除文件时的钩子
      handleRemove2(file, fileList) {
          console.log("url222==="+JSON.stringify(fileList));
          this.fileList3=[];
          for (let index = 0; index < fileList.length; index++) {
              if(fileList[index].response!=null){
              console.log("url5555==="+fileList[index].response.url);
              this.fileList3.push(fileList[index].response.url);
              }else{
                  console.log("url5555==="+fileList[index].url22);
                  this.fileList3.push(fileList[index].url22);
              }
          }
          this.form.goodsimg2 ="1";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview2(file) {
          console.log("url==="+file.url);
          this.fileList3.push(file.url);
          this.form.goodsimg2 = "1";
          this.dialogVisible = true;
      },
    //上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 50;
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
        this.$notify.warning({
          title: '警告',
          message: '请上传正确的视频格式'
        })
        return false;
      }
      if (!fileSize) {
        this.$notify.warning({
          title: '警告',
          message: '视频大小不能超过50MB'
        })
        return false;
      }
      this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;

      //前台上传地址
      /**  if (file.status == 'success' ) {
             this.form.showVideoPath = file.url;;
          } else {
              this.$notify.warning({
                  title: '警告',
                  message: '上传失败，请重新上传'
              })
        }**/
      //后台上传地址

      if (res.code == 200) {
        alert("视频上传成功");
        //this.form.showVideoPath = "https://szqykj-1307293036.cos.ap-guangzhou.myqcloud.com/"+res.url;
        this.form.advImg=res.url;
      } else {
        this.$notify.warning({
          title: '警告',
          message: res.msg
        })
      }
    },
    //上传前回调
    beforeUploadVideo2(file) {
      var fileSize = file.size / 1024 / 1024 < 50;
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
        this.$notify.warning({
          title: '警告',
          message: '请上传正确的视频格式'
        })
        return false;
      }
      if (!fileSize) {
        this.$notify.warning({
          title: '警告',
          message: '视频大小不能超过50MB'
        })
        return false;
      }
      this.isShowUploadVideo2 = false;
    },
    // 删除视频文件
    handleRemoveVideo() {
      this.form.advImg="";
      this.form.showVideoPath="";
      console.log("url77777===");

    },
    handleRemoveVideo2() {
      this.form.advImg2="";
      this.form.showVideoPath2="";
      console.log("url77777===");

    },
    //进度条
    uploadVideoProcess2(event, file, fileList) {
      this.videoFlag2 = true;
      this.videoUploadPercent2 = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleVideoSuccess2(res, file) {
      this.isShowUploadVideo2 = true;
      this.videoFlag2 = false;
      this.videoUploadPercent2 = 0;

      //前台上传地址
      /**  if (file.status == 'success' ) {
             this.form.showVideoPath = file.url;;
          } else {
              this.$notify.warning({
                  title: '警告',
                  message: '上传失败，请重新上传'
              })
        }**/
      //后台上传地址

      if (res.code == 200) {
        alert("视频上传成功");
        //this.form.showVideoPath2 = "https://szqykj-1307293036.cos.ap-guangzhou.myqcloud.com/"+res.url;
        this.form.advImg2=res.url;
      } else {
        this.$notify.warning({
          title: '警告',
          message: res.msg
        })
      }
    },
    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {
            console.log("url4444==="+this.fileList3.length);
            console.log("url5555==="+this.fileList3);
          console.log("url5555==="+this.fileList3);
                let types=1;
                if(this.checked){
                    types=0;
                }
            this.loading = true;
                // this.form.goodsnote=encodeURIComponent(this.form.goodsnote);
          if(this.form.googstype_id_two!=null && this.form.googstype_id_two!="") {
            let aaaaa = this.form.googstype_id_two + "";
            this.form.googstype_id_two = aaaaa;
          }

          if(this.form.agent_two_id!=null && this.form.agent_two_id!="") {
            let bbbb = this.form.agent_two_id + "";
            this.form.agent_two_id = bbbb;
          }
          let ggg_one="";
          let ggg_two="";
          let ggg_three="";
          for (let index = 0; index < this.form.ruletype_id.length; index++) {
            let aaa=this.form.ruletype_id[index]+"";
            if(aaa.indexOf(",")>-1){
              let tmpCenter = aaa.split(',');
              ggg_three+=tmpCenter[1]+"-";
             // ggg_one += aaa.replace(',','-')+",";
            }else{
              if(ggg_three!=null && ggg_three!="") {
                ggg_one=ggg_one.substring(0,ggg_one.length-2);
                ggg_one +=ggg_three.substring(0,ggg_three.length-1)+",";
              }
              ggg_three="";
              ggg_two += this.form.ruletype_id[index]+",";
              ggg_one += "0,";
            }

          }
          if(ggg_three!=null && ggg_three!="") {
            ggg_one=ggg_one.substring(0,ggg_one.length-2);
            ggg_one +=ggg_three.substring(0,ggg_three.length-1)+",";
          }

          if(ggg_one!=null && ggg_one!="") {
            ggg_one=ggg_one.substring(0,ggg_one.length-1);
          }
          if(ggg_two!=null && ggg_two!="") {
            ggg_two=ggg_two.substring(0,ggg_two.length-1);
          }
          console.info("********" + ggg_one);
          console.info("********" + ggg_two);
          //return false;
          //  if(aaaaa!=null && aaaaa!="")
           // this.form.googstype_id_two = aaaaa.substring(1, aaaaa.length- 1).replace("\"", "");

            agentService.saveIntegralGoods({ ...this.form,agentid:util.cookies.get('agentid'),types:types,id:this.oneagent.id,detailsimg:this.fileList3,goodsimg:this.fileList1,ggg:'2',ggg_two:ggg_one,ggg_one:ggg_two})
                .then(data => {
                    this.loading = false;
                    this.dialogVisible = false;
                    this.$emit("submit");
                });


        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

